import { memo } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { ErrorAlertIcon as ErrorIcon } from "../../assets/icons";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { useStore } from "../../store/globalState";
import { useSessionStore } from "../../store/useSessionStore";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";

const MOCK_RETURN_TO_CHAT_URL = "https://example.com/whatsapp-return";
const MOCK_OPERATION_ID = "op_gallery_demo_001";

/**
 * Gallery-safe Lola terminal: single-use payment link already consumed.
 */
export const LinkAlreadyUsedPage = memo(() => {
  const { t } = useTranslation("lola");
  const { theme } = useStore();
  const session = useSessionStore((s) => s.session);
  const chatUrl = session.data?.config?.returnToChatUrl ?? MOCK_RETURN_TO_CHAT_URL;
  const operationId =
    session.data?.config?.usage?.operationId ?? MOCK_OPERATION_ID;
  const canReturnToChat = /^https?:\/\//i.test(chatUrl);

  const colorConfig = theme.errorView;
  const {
    backgroundBtn,
    textColorBtn,
    title,
    bodyCopy,
    iconColors,
    backgroundIcon,
  } = colorConfig;

  const handleReturnToChat = () => {
    if (!canReturnToChat) return;
    window.open(chatUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark backgroundIcon={backgroundIcon}>
            <ErrorIcon size={60} colors={iconColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("error.linkAlreadyUsed")}
              highlightColor={title}
              secudnary=""
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>
              {t("error.linkAlreadyUsedMessage")}
            </BodyCopy>
            {operationId && (
              <BodyCopy textColor={bodyCopy}>
                {t("error.linkAlreadyUsedOperation", { operationId })}
              </BodyCopy>
            )}
          </section>
        </section>
      </Layout.Content>
      {canReturnToChat && (
        <Layout.Footer>
          <section className="footer-section">
            <Button
              size="small"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={handleReturnToChat}
            >
              {t("error.returnToChat")}
            </Button>
          </section>
        </Layout.Footer>
      )}
    </AuraLayout>
  );
});
